import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {SubscriptionItem} from '../types';
import {FormWithButtons} from "@flexinet/ui-components";
import {stage} from "../../../config/stage.ts";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<SubscriptionItem, 'id'>,
    handleSubmit: (values: SubscriptionItem) => void,
    handleCancel?: () => void
}) => {


    const onSubmit = async (values: SubscriptionItem) => {

        handleSubmit(values);

    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {
        subscription: '',
        price: '',
    } as SubscriptionItem;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }


    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting} handleCancel={onCancel}
                                 debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>
            )}


        </Formik>
    );
};
